import { Section } from '@insify/components';
import { CoBrandingLogoContent } from '@insify/funnel-components';

import { useCoBranding } from '../../hooks/useCoBranding';

import * as styles from './ContentWithPartnerLogo.module.css';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type PageType = React.ComponentType<any>;

export const withOptionalPartnerLogo = <T,>(Page: PageType) => {
  return (props: T) => {
    const { hasCoBranding } = useCoBranding();
    if (hasCoBranding) {
      return <ContentWithPartnerLogo<T> Page={Page} {...props} />;
    }
    return <Page {...props} />;
  };
};

const ContentWithPartnerLogo = <T,>({ Page, ...props }: T & { Page: PageType }) => {
  const { hasCoBrandingLoaded, branding } = useCoBranding();
  return (
    <div className={styles.partnerContent}>
      <Section>
        {hasCoBrandingLoaded ? <CoBrandingLogoContent className={styles.partnerLogo} branding={branding} /> : undefined}
      </Section>
      <Page {...props} />
    </div>
  );
};
